import React from "react";
import { formatPhone } from "../../../../util/credit";
import { ICreditorInfo } from "../../../../store/credit/types";
interface IProps {
    data?: ICreditorInfo[];
}
const PrintCreditHistoryCreditorContactInfoSingle: React.FunctionComponent<IProps> = (props) => {
    return (
        <React.Fragment>
            {props.data != null && props.data.length > 0 ? (
                <React.Fragment>
                    <h4 className=" margin-vertical-s">{props.data[0].bureau}</h4>
                    <div className="table-container scroll">
                        <table className="m-table-generic">
                            <thead>
                                <tr>
                                    <th scope="col">Name</th>
                                    <th scope="col">Address</th>
                                    <th scope="col">Phone Number</th>
                                </tr>
                            </thead>
                            <tbody>
                                {props.data.map((creditor) => (
                                    <tr key={"CreditorContact_ " + creditor.index}>
                                        <td>{creditor.name}</td>
                                        <td>{creditor.address}</td>
                                        <td>{!creditor.telephone ? "" : formatPhone(creditor.telephone)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </React.Fragment>
            ) : (
                ""
            )}
        </React.Fragment>
    );
};

export default PrintCreditHistoryCreditorContactInfoSingle;
